import { ElementMatcher } from './common/ElementMatcher';
export class DrawerToggle {
    constructor(win = window) {
        this.win = win;
        this.doc = this.win.document;
        this.openedDrawer = null;
    }
    activate() {
        this.applyDefaultDrawerName();
        this.applyReadyDrawerClass();
        this.setupDrawerOverlay();
        window.addEventListener('click', (event) => {
            if (!(event.target instanceof HTMLElement))
                return;
            const element = event.target;
            const openedDrawer = this.openedDrawer;
            if (openedDrawer) {
                if (this.isDrawerOverlayClicked(openedDrawer, element)
                    || this.isDrawerTogglerClicked(openedDrawer, element)) {
                    this.closeDrawer(openedDrawer);
                }
                else if (this.isAnyTogglerClicked(element)) {
                    this.closeDrawer(openedDrawer);
                    this.openDrawer(element.dataset.drawerToggler || 'main');
                }
            }
            else if (this.isAnyTogglerClicked(element)) {
                this.openDrawer(element.dataset.drawerToggler || 'main');
            }
        });
    }
    setupDrawerOverlay() {
        const overlay = this.doc.createElement('div');
        overlay.classList.add('drawer-overlay');
        this.doc.body.prepend(overlay);
    }
    applyReadyDrawerClass() {
        Array.from(this.doc.querySelectorAll('[data-drawer]'))
            .forEach(element => element.classList.add('ready'));
    }
    applyDefaultDrawerName() {
        const defaultDrawerName = 'main';
        ['data-drawer', 'data-drawer-toggler'].forEach(name => Array.from(this.doc.querySelectorAll(`[${name}]`))
            .filter(element => element.getAttribute(`${name}`) === '')
            .forEach(element => element.setAttribute(`${name}`, defaultDrawerName)));
    }
    isAnyTogglerClicked(target) {
        return ElementMatcher.findParentOrSelf(target, '[data-drawer-toggler]');
    }
    isDrawerTogglerClicked(openedDrawer, target) {
        return !!ElementMatcher.findParentOrSelf(target, `[data-drawer-toggler=${openedDrawer}]`);
    }
    isDrawerOverlayClicked(openedDrawer, target) {
        return !!ElementMatcher.findParentOrSelf(target, '.drawer-overlay');
    }
    openDrawer(navbarName) {
        this.findOverlay(overlay => overlay.classList.add('show'));
        this.findToggler(navbarName, (toggler => toggler.classList.add('show')));
        this.findDrawer(navbarName, (drawer => drawer.classList.add('show')));
        this.doc.body.classList.add('drawer-opened');
        this.openedDrawer = navbarName;
    }
    closeDrawer(navbarName) {
        this.findOverlay(overlay => overlay.classList.remove('show'));
        this.findToggler(navbarName, (toggler => toggler.classList.remove('show')));
        this.findDrawer(navbarName, (drawer => drawer.classList.remove('show')));
        this.doc.body.classList.remove('drawer-opened');
        this.openedDrawer = null;
    }
    findToggler(drawerName, action) {
        const toggler = this.doc.querySelector(`[data-drawer-toggler=${drawerName}]`);
        toggler && action(toggler);
    }
    findDrawer(drawerName, action) {
        const drawer = this.doc.querySelector(`[data-drawer=${drawerName}]`);
        drawer && action(drawer);
    }
    findOverlay(action) {
        const overlay = this.doc.querySelector('.drawer-overlay');
        overlay && action(overlay);
    }
}
